import { render } from "./SupervisorDocumentsDetailsPage.vue?vue&type=template&id=50bfc20a&scoped=true"
import script from "./SupervisorDocumentsDetailsPage.vue?vue&type=script&lang=js"
export * from "./SupervisorDocumentsDetailsPage.vue?vue&type=script&lang=js"

import "./SupervisorDocumentsDetailsPage.vue?vue&type=style&index=0&id=50bfc20a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50bfc20a"]])

export default __exports__